/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ReactionButtonContainer_settings = {
    readonly reaction: {
        readonly label: string;
        readonly labelActive: string;
        readonly icon: string;
        readonly iconActive: string | null;
    };
    readonly " $refType": "ReactionButtonContainer_settings";
};
export type ReactionButtonContainer_settings$data = ReactionButtonContainer_settings;
export type ReactionButtonContainer_settings$key = {
    readonly " $data"?: ReactionButtonContainer_settings$data;
    readonly " $fragmentRefs": FragmentRefs<"ReactionButtonContainer_settings">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ReactionButtonContainer_settings",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "ReactionConfiguration",
            "kind": "LinkedField",
            "name": "reaction",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "label",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "labelActive",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "icon",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "iconActive",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "Settings",
    "abstractKey": null
} as any);
(node as any).hash = '80fb77550d7dcc4ec52c04294ba100e0';
export default node;
